/**
 * Spell school badge icon sources.
 *
 * The v2 (SVG) source is served from the shared DDB media bucket and is gated
 * behind the `spell-school-icons-v2` release flag. When that flag is retired,
 * delete `LEGACY_SPELL_SCHOOL_ICON_BASE_URL` and the `useV2` branch below.
 *
 */
export const SPELL_SCHOOL_ICON_BASE_URL =
  "https://media.dndbeyond.com/media/spell-school-icons";

export const LEGACY_SPELL_SCHOOL_ICON_BASE_URL =
  "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/spell-schools/35";

export const getSpellSchoolIconUrl = (
  school: string | null | undefined,
  useV2: boolean
): string => {
  const slug = school?.toLowerCase() ?? "";

  return useV2
    ? `${SPELL_SCHOOL_ICON_BASE_URL}/${slug}.svg`
    : `${LEGACY_SPELL_SCHOOL_ICON_BASE_URL}/${slug}.png`;
};
